import { moduleProviderFactory } from 'core/providers';
import { EligibilityStatusEdit, EligibilityStatusList } from 'application/eligibility-status/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.eligibility-status',
                pattern: '/eligibility-status',
                children: [
                    {
                        name: 'master.app.main.eligibility-status.list',
                        pattern: '',
                        tabTitle: 'ELIGIBILITY_STATUS.LIST.TITLE_SECONDARY',
                        component: EligibilityStatusList,
                        data: {
                            title: 'ELIGIBILITY_STATUS.LIST.TITLE_SECONDARY'
                        }
                    },
                    {
                        name: 'master.app.main.eligibility-status.create',
                        pattern: '/create',
                        tabTitle: 'Create Eligibility Status',
                        component: EligibilityStatusEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'ELIGIBILITY_STATUS.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.eligibility-status.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Eligibility Status',
                        component: EligibilityStatusEdit,
                        authorization: 'portalSection.update',
                        data: {
                            title: 'ELIGIBILITY_STATUS.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.ELIGIBILITY_STATUSS_SUB',
                        route: 'master.app.main.eligibility-status.list',
                        order: 3,
                    }                    
                ]
            }
        ]
    });
})();
